import Home from './Pages/Home';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import ExternalWebsite from './Pages/ExternalWebsite';
import Card from './Pages/Cards';
import Mance from './Pages/Mance';
import 'bootstrap/dist/css/bootstrap.min.css';

function App() {
  return (
    <Router>
      <Routes>
      <Route path="/packredeem" element={<Home />} />
      <Route path="/mance&leemon" element={<Mance />} />
      <Route path="/packredeem/" element={<Home />} />
      <Route path="/cardredeem" element={<Card />} />
      {/* <Route path="/" element={<Card />} /> */}
      <Route path="/" element={<ExternalWebsite url="/home/" />} /> 
      <Route path="/comingSoon" element={<ExternalWebsite url="/home/comingSoon.html" />} />
      <Route path="/faq" element={<ExternalWebsite url="/home/FAQ.html" />} />
      <Route path="/terms" element={<ExternalWebsite url="/home/terms.html" />} />

      </Routes>
    </Router>
  );
}

export default App;
